module.exports = __webpack_public_path__ + "img/bragin.29f5c3df.png";